/* Import Css Style */
import './styles/Team.css'

/* Components imports */
// import Rachid from "../assets/Team/RachidCropped.jpeg";
import Rachid from "../assets/Team/Rachid_Djebbouri_SosJeunesPousses_Entrepeneuriat_Entreprendre_Quartier_QPV_Grenoble_Metropole_Echirolles_Marketing_Communication_BuisnessPlan_BP_FrenchTech_Incubateur_Accompagnement_Feminin_Financement_Subvention.png";
import Salim from "../assets/Team/Salim.png";
import Myriam from "../assets/Team/Myriam.png";
import Nesrine from "../assets/Team/Nesrine.png";
import Nino from "../assets/Team/nino.png";
import karim from "../assets/Team/karim2.png";
import karima from "../assets/Team/karima2.png";
import maroua from "../assets/Team/Maroua_Hachani.png";
import {BUTTON_BLHS} from "../subComponents/BUTTON_BLHS";

 
export const Team = (props) =>{
    return(
        <div  className={"Team_BiggestContainer"} id="Team_BiggestContainer">
            <h1 className="HeaderGrabPhrase">
                Acteur de l'entrepreneuriat
            </h1>
            <h1 className="HeaderTItleTeam">
                 L’ADN de SOSJP et d'Elone est d’être <a className="UnderLineHeader">la boussole des entrepreneurs.euses des quartiers :</a> <br/>
                Créatif, empathique avec une grande connaissance de l'écosystème entrepreneurial
                <br/>
                <a className={"HeaderTItleTeamSecond"}>
                    <br/>
Depuis plus de 12 ans, nous connaissons les galères, les détours et les bons raccourcis pour réussir.<br/>
Notre spécialité : propulser les entrepreneurs.<br/>

On crée ton parcours sur mesure, on t’aide à obtenir toutes les subventions auxquelles tu as droit, et on t’accompagne pas à pas pour transformer ton idée en réussite.</a>
            </h1>
            <div className={"Team_Container"}>

                <div className={"Team_Member"}>
                    <div className="trapeze">
                        <img
                            src={Rachid}
                            alt="Rachid Djebbouri"
                            className="Member_Photo"
                        />
                    </div>

                    <div className="propsContainer">
                    <div className={"Name_Member"}>Rachid Djebbouri</div>
                    <div className={"Function_Member"}>Delegué Général</div>
                    <div className={"Function_Member"}>Chef de projet Sos Jeunes Pousses Citéslab Echirolles</div>

                    <div className={"Social_Member"}>
            <BUTTON_BLHS
                content = "Entreprend sur Échirolles"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://profile.vkard.io/3e78f7ea-d0c3-41ea-ac8a-d6399ba20e90/e980722991"
            />
                        </div>
                    </div>
                </div>



                <div className={"Team_Member"}>
                    <div className="trapeze">
                        <img
                            src={Salim}
                            alt="Salim "
                            className="Member_Photo"
                        />
                    </div>

                    <div className="propsContainer">
                    <div className={"Name_Member"}>Salim Boukhalfa </div>
                    <div className={"Function_Member"}>Chef de projet SOS Jeunes Pousses Citéslab Fontaine</div>

                    <div className={"Social_Member"}>
            <BUTTON_BLHS
                content = "Entreprend sur Fontaine"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://profile.vkard.io/7b0b332d-c3ed-4d90-ad5e-0ed00d310050/369eebd55d"
            />
                        </div>
                    </div>
                </div>


                <div className={"Team_Member"}>
                    <div className="trapeze">
                        <img
                            src={Myriam}
                            alt="Myriam Djebbouri"
                            className="Member_Photo"
                        />
                    </div>

                    <div className="propsContainer">
                    <div className={"Name_Member"}>Myriam Djebbouri</div>
                    <div className={"Function_Member"}>Co-Fondatrice SOSJP.</div>
                    <div className={"Function_Member"}>Graphiste Bénévole</div>

                    <div className={"Social_Member"}>
            <BUTTON_BLHS
                content = "Contactez Myriam"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://profile.vkard.io/3e78f7ea-d0c3-41ea-ac8a-d6399ba20e90/e980722991"
            />
                        </div>
                    </div>
                </div>
                        


                


                <div className={"Team_Member"}>
                    <div className="trapeze">
                        <img
                            src={Nesrine}
                            alt="Nesrine"
                            className="Member_Photo"
                        />
                    </div>

                    <div className="propsContainer">
                    <div className={"Name_Member"}>Nesrine Ouaziz</div>
                    <div className={"Function_Member"}>Cheffe de projet Communication et Formation (Freelance QPV)</div>

                    <div className={"Social_Member"}>
            <BUTTON_BLHS
                content = "Contactez Nesrine"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://www.linkedin.com/in/ouaziznesrine?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
            />
                        </div>
                    </div>
                </div>


                <div className={"Team_Member"}>
                    <div className="trapeze">
                        <img
                            src={Nino}
                            alt="Nino Mendez"
                            className="Member_Photo"
                        />
                    </div>

                    <div className="propsContainer">
                    <div className={"Name_Member"}>Nino Mendez</div>
                    <div className={"Function_Member"}>Chargé de production visuelle (Freelance QPV)</div>

                    <div className={"Social_Member"}>
            <BUTTON_BLHS
                content = "Contactez Nino"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://linktr.ee/nmc.production?fbclid=PAQ0xDSwMaeBpleHRuA2FlbQIxMQABp4cYX_Y8dcKrsNBQhSdLQ8RNC5Tx563LjDQ9lzqES20EstF11CdQUSFt8iTD_aem_6qN4QZ_acqcYRHTvAp1yhA"
            />
                        </div>
                    </div>
                </div>


                <div className={"Team_Member"}>
                    <div className="trapeze">
                        <img
                            src={karim}
                            alt="Karim Moujahed"
                            className="Member_Photo"
                        />
                    </div>

                    <div className="propsContainer">
                    <div className={"Name_Member"}>Karim Moujahed</div>
                    <div className={"Function_Member"}>Closer et développeur web (Freelance QPV) </div>
                    <div className={"Function_Member"}>Trésorier Bénévole de l'association SOSJP. </div>

                    <div className={"Social_Member"}>
            <BUTTON_BLHS
                content = "Contactez Karim"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://www.linkedin.com/in/karim-moujahed-680165200?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
            />
                        </div>
                    </div>
                </div>


                <div className={"Team_Member"}>
                    <div className="trapeze">
                        <img
                            src={karima}
                            alt="Karima Oulkadi"
                            className="Member_Photo"
                        />
                    </div>

                    <div className="propsContainer">
                    <div className={"Name_Member"}>Karima Oulkadi</div>
                    <div className={"Function_Member"}>Contrôle de gestion et Analyse  financière (Freelance)</div>

                    <div className={"Social_Member"}>
            <BUTTON_BLHS
                content = "Contactez Karima"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://www.linkedin.com/in/karima-oulkadi-a2316a1a0?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
            />
                        </div>
                    </div>
                </div>



                <div className={"Team_Member"}>
                    <div className="trapeze">
                        <img
                            src={maroua}
                            alt="Maroua Hachani"
                            className="Member_Photo"
                        />
                    </div>

                    <div className="propsContainer">
                    <div className={"Name_Member"}>Maroua Hachani</div>
                    <div className={"Function_Member"}>Cheffe de projet Sos Jeunes Pousses Citéslab Échirolles</div>

                    <div className={"Social_Member"}>
            <BUTTON_BLHS
                content = "Contactez Maroua"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                class="BUTTON_FOCUS4_COMP2"
                urlTo="https://profile.vkard.io/0ab14a65-75d6-4cf8-99e8-3816cc10de22/d430887a8c"
            />
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )

}
